import { render } from "./new-carousel.vue?vue&type=template&id=7e1a701e"
import script from "./new-carousel.vue?vue&type=script&lang=js"
export * from "./new-carousel.vue?vue&type=script&lang=js"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__